import React from 'react'
import { useWillPipe } from '@morningtrain/react-helpers'
import PropTypes from 'prop-types'
import useSmartviewManager from '../hooks/use-smartview-manager'

function MountSmartviewOnPipe (props) {
  const smartviewManager = useSmartviewManager()

  useWillPipe(function (payload) {
    let { smartview, replace, keepTreeOnPush, ...forwardProps } = props

    if (typeof smartview === 'function') {
      smartview = smartview(payload)
    }

    if (replace) {
      return smartviewManager.mount(smartview, forwardProps)
    }

    return smartviewManager.push(smartview, forwardProps, keepTreeOnPush)
  })

  return null
}

MountSmartviewOnPipe.defaultProps = {
  replace: false
}

MountSmartviewOnPipe.propTypes = {
  smartview: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func
  ]).isRequired,
  replace: PropTypes.bool,
  keepTreeOnPush: PropTypes.bool
}

export default MountSmartviewOnPipe
